import styled from 'styled-components';

export const NoteForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
